module.exports = "https://web-assets.ifttt.com/packs/media/components/check-66910183.svg";